module.exports = __webpack_public_path__ + "AkanshaMehta-74d5378a.webp";